export const setCustomPageTitle = (title?: string) => {
	if (title) {
		document.title = `${title} – meinUnterricht`;
	} else {
		document.title = 'meinUnterricht';
	}
};
